import { render, staticRenderFns } from "./ProductModelIndexScreen.vue?vue&type=template&id=3b5fe798&"
import script from "./ProductModelIndexScreen.vue?vue&type=script&lang=js&"
export * from "./ProductModelIndexScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports